import './scss/main.scss';
import setupGlobals from './js/globals';
setupGlobals();
console.log('entry.js loaded');

window.supportAjaxUploadWithProgress = function() {
    return supportFileAPI() && supportAjaxUploadProgressEvents() && supportFormData();
  
    function supportFileAPI() {
      var fi = document.createElement('INPUT');
      fi.type = 'file';
      return 'files' in fi;
    };
  
    function supportAjaxUploadProgressEvents() {
      var xhr = new XMLHttpRequest();
      return !! (xhr && ('upload' in xhr) && ('onprogress' in xhr.upload));
    };
  
    function supportFormData() {
      return !! window.FormData;
    }
}
$(document).ready(()=> {

    const modal = $('#bar-more-details');
    modal.on('hidden.bs.modal', function (e) {
        $(document).off('keyup',escapePress);
    });
    modal.on('shown.bs.modal', function (e) {
        $(document).on('keyup',escapePress);
    });
    function escapePress (e) {
        if(e.key === "Escape") {
            modal.modal('hide');            
        }
    }
    $(document).on('click', '.show-more-details', function(){
        const card = $(this).closest('.card');
        modal.find('iframe').attr('src','');
        const modal_content = card.find('.extended-details');
        const last_updated = modal_content.data('last-updated');
        modal.find('.modal-footer .last-updated span').text(last_updated);
        modal.find('#bar-more-detailsLabel').text(card.find('.card-title a').text());
        modal.find('.modal-body').empty().append(modal_content.html());
        let address = card.find('.hidden-address').val();
        if(address != ''){
            modal.find('iframe').attr('src',`https://www.google.com/maps/embed/v1/place?q=${address}&key=AIzaSyAcePzV7bWUvycrzg77mq5DbD37PgekgIs`);
        }
        modal.modal('show');
        $('[data-toggle="tooltip"]').tooltip('hide');
    })

    $.expr[':'].icontains = function(a, i, m) {
        //replace mark as viewed as it's a button text and shouldn't be searched
        return $(a).text().replace('Mark as Viewed','').toUpperCase()
        .indexOf(m[3].toUpperCase()) >= 0;
    };
    
    $('#search').keyup(function(e) {
        let search = $(this).val();
        $('.card.biz-card').addClass('search-shown');
        if(search != ''){
            $(`.card.biz-card`).not(`:icontains(${search})`).removeClass('search-shown');
        }
        if($('.card.search-shown').length == 0){
            $('#no-results').removeClass('d-none');
        }
        else {
            $('#no-results').addClass('d-none');
        }
    });

    

    $('[data-toggle="tooltip"]').tooltip();
    tinymce.init({
        selector: 'textarea.tinymce',
        statusbar: false,
        plugins: 'link autolink code',
        menubar: 'edit tools',
        force_p_newlines : false,
        force_br_newlines : true,
        forced_root_block : false,
        toolbar: 'undo redo | link | underline bold italic code',
        default_link_target: "_blank"
    });
    tinymce.init({
        selector: 'textarea.kitchensink-tinymce',
        plugins: 'print preview spellchecker paste autolink link table hr insertdatetime advlist lists  quickbars code',
        statusbar: false,
        menubar: 'file edit view insert format tools table',
        toolbar: 'spellchecker | bold italic underline | fontselect fontsizeselect formatselect |  numlist bullist | forecolor backcolor removeformat | fullscreen  preview | link code',
        
        height: 250,
        quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 quicktable',
        browser_spellcheck: true,
        toolbar_mode: 'sliding',
        contextmenu: "link image imagetools table",
        default_link_target: "_blank"
    });
    //file upload
    $('#logo-submit').on('click', function(){
        if(supportAjaxUploadWithProgress() == false){
            alert("Your device/browser does not support file upload.");
            return false;
        }
        showProcessingOverlay();
        var formData = new FormData();
        var fileInput = $('#logo-upload')[0];
        var file = fileInput.files[0];
        
        formData.append('file', file);
        formData.append('restaurant_id', $('#restaurant_id').val());
        var xhr = new XMLHttpRequest();
        // Add any event handlers here...
        xhr.open('POST', window.globals.AJAX_ROOT + 'pub/uploadLogo', true);
        xhr.send(formData);
       
        
        xhr.addEventListener('readystatechange', onreadystatechangeHandler, false);
    });
      // Handle the response from the server
    function onreadystatechangeHandler(evt) {
        var status, text, readyState;
    
        try {
            readyState = evt.target.readyState;
            text = evt.target.responseText;
            status = evt.target.status;
        }
        catch(e) {
            return;
        }
    
        if (readyState == 4 && status == '200' && evt.target.responseText) {
            try {
                const response = JSON.parse(evt.target.responseText);
                if(response.status == 'success'){
                    if(response.uploaded == true){
                        let path = response.path;
                        $("#logo-wrapper img").attr('src',path);
                        if($('#logo-wrapper').hasClass('d-none')){
                            $('#logo-wrapper').removeClass('d-none');
                        }
                    }
                }
                
            }
            catch(e){
                alert("ERROR saving file");
            }
            hideProcessingOverlay();
          
        }
    }
});